export const getLastGivenMonths = (numMonths: number): { label: string; year: number; month: number }[] => {
    const now = new Date();
    const result: { label: string; year: number; month: number }[] = [];

    for (let i = numMonths - 1; i >= 0; i--) {
      const d = new Date(Date.UTC(now.getFullYear(), now.getMonth() - i, 1));
      result.push({
        label: d.toLocaleString('default', { month: 'short', year: 'numeric' }),
        year: d.getUTCFullYear(),
        month: d.getUTCMonth(),
      });
    }
    return result;
  };